import React from 'react';
import { Button, Row} from 'reactstrap';
import { StatusRightTitle } from "@/components/";
import styles from './index.module.scss';
import { Dictionary, Enums } from "@utils";

interface ButtonProps {
    save(data: any): void;
    step: number;
    followupLabels: Dictionary<string, string>;
    screen: string;
    data: any;
    rightTitle: string;
}

const Buttons: React.FC<any> = ({save, step, rightTitle, followupLabels, data, screen}: ButtonProps) => { 
    let btnDisabled = (screen === Enums.FollowupState.view)

    return (
        <div className={styles.stickyTitle}>
            <div className={styles.mainButtons}> 
                <Row xs={1} sm={1} md={1} lg={1} xl={1}>   
                    <Button onClick={() => save(step)} disabled={btnDisabled}>
                        {followupLabels.get("saveBtn")}
                    </Button>
                </Row>
            </div>
            <div className={styles.divRight} >
                {(data?.interventionLine) ?
                    <StatusRightTitle 
                        title={rightTitle} 
                        info={data?.interventionLine}
                        subtitle={data?.description}
                    /> 
                :
                    <StatusRightTitle 
                        title={rightTitle} 
                        subtitle={data?.description}
                    /> 
                }
            </div>
        </div>                 
    );
}

export default Buttons;